<template>
  <div id="attendance-list" class=" ">
    <div class="container admin-wrap">
      <div class="row header mb-2">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">{{ lang('Attendance') }} ( {{ currentDateWithAlphabet }} )</h3>
        </div>
        <div class="col-lg-7">
          <div class="searchingArea attendance-search" style="display: flex">
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="showTempImportModal()"
              v-if="schID !== 'SCH201400000471' && schID !== 'SCH201500000054' && schID !== 'SCH201500000074'"
            >
              {{ lang('Thermal Scanner Import') }}
            </button>

            <button type="button" class="btn btn-primary" v-on:click="viewAttendanceList()" v-if="schID === 'SCH201800000510'">
              {{ lang('View Attendance List') }}
            </button>

            <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select" @change="Load()">
              <el-option v-for="item in ddlClassList" :key="item.ClassID" :label="item.ClassName" :value="item.ClassID"> </el-option>
            </el-select>
          </div>

          <div
            class="row"
            style="margin-top: 15px"
            v-if="schID === 'SCH201400000471' || schID === 'SCH201500000054' || schID === 'SCH201500000074' || schID === 'SCH201400000553'"
          >
            <button class="btn btn-primary" v-on:click="showTemp('qr')">Scan Temperature with QR code</button>
            <button class="btn btn-primary" v-on:click="showTemp('non-qr')">Scan Temperature without QR code</button>
          </div>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="studentList.length < 1">
          <strong v-if="hideStudentList === false">
            {{ lang('Please select Class...') }}
          </strong>
          <strong v-if="hideStudentList === true">
            {{ lang('No Student Found...') }}
          </strong>
          <img src="../assets/attendance.jpg" />
        </div>
        <div v-if="studentList.length > 0" class="responsive-table">
          <div class="divSortBy">
            <label>Sort By</label>
            <el-select v-model="sortOptionsSelected" @change="changeSort()" placeholder="Sort By" class="pro-edt-select">
              <el-option v-for="item in sortOptions" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
          <table class="attTable">
            <tr>
              <th>{{ lang('Student Name') }}</th>
              <th>
                <span v-if="bundleAttendance === false">{{ lang('Attendance') }} </span>
                <el-select
                  :placeholder="lang('Select Attendance For All')"
                  v-model="studentCheck"
                  @change="selectedAttendance()"
                  class=""
                  v-if="selectallStudent === false"
                >
                  <el-option v-for="itemCheckList in checkListSelect" :key="itemCheckList" :label="lang(itemCheckList)" :value="itemCheckList"> </el-option>
                </el-select>
              </th>
              <th>{{ lang('Remarks') }}</th>
              <th>{{ lang('Parents Contact') }}</th>
              <th>{{ lang('Pickup Mode') }}</th>
              <th>{{ lang('ECA') }}</th>
            </tr>
            <tr v-for="(item, i) in studentList" ref="studentList_Update" :key="item.Student_ID + item.markingStatus">
              <td style="display: none"><input type="text" class="form-control" :value="item.Index_No" ref="studentIndexNo" /></td>

              <td style="display: none">{{ item.checked }}</td>
              <td>
                <label class="lblStudentName">{{ item.Student_Name }}</label>
              </td>
              <td class="">
                <el-select
                  ref="studentCheckList"
                  :placeholder="lang('Select')"
                  v-model="item.markingStatus"
                  @change="e => AttendanceByStudent(e, item)"
                  :class="[
                    { attend: item.markingStatus === 'Present' },
                    { late: item.markingStatus === 'Late' },
                    { absent: item.markingStatus === 'Absent' },
                    { sick: item.markingStatus === 'Sick' },
                    { holiday: item.markingStatus === 'On Holiday' },
                    { home: item.markingStatus === 'Sent Home' },
                  ]"
                >
                  <el-option v-for="itemCheckList in checkListSelect" :key="itemCheckList" :label="lang(itemCheckList)" :value="itemCheckList"> </el-option>
                </el-select>

                <div v-if="item.tempIn" style="margin-top: 5px">Temperature reading: {{ item.tempIn }}</div>
                <div v-if="item.tempIn">Time In: {{ item.timeIn }}</div>
                <div v-if="item.timeOut">Time Out: {{ item.timeOut }}</div>
              </td>
              <td>
                <input type="text" class="form-control" v-model="item.remarks" ref="studentRemark" />
              </td>
              <td>
                <select class="parentsMobileNo">
                  <option v-if="item.fatherMobile !== ''">{{ lang('Father') }} - {{ item.fatherMobile }}</option>
                  <option v-if="item.fatherMobile === ''">{{ lang('Father') }} - {{ lang('Nil') }}</option>
                  <option v-if="item.motherMobile !== ''">{{ lang('Mother') }} - {{ item.motherMobile }}</option>
                  <option v-if="item.motherMobile === ''">{{ lang('Mother') }} - {{ lang('Nil') }}</option>
                </select>
              </td>
              <td v-if="item.busOutNo">
                <label class="lblBusNo">{{ item.busOutNo }}</label>
              </td>
              <td v-if="!item.busOutNo"><label class="lblBusNo">-</label></td>
              <td>
                <label class="lblEcaName">{{ item.ecaName }}</label>
              </td>
            </tr>
          </table>
        </div>
        <div class="text-center form-group col-lg-12" style="margin-top: 20px" v-if="studentList.length > 0">
          <button type="button" class="btn btn-primary float-right" v-on:click="Save">{{ lang('Save') }}</button>
        </div>
      </div>
      <b-modal size="lg" :title="lang('Thermal Scanner Import')" ok-only ok-variant="secondary" hide-footer ref="tempImportModal">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <textarea rows="4" v-model="tempDeviceOutput" class="taTempImport"> </textarea>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 tempImportButtonArea">
          <button v-on:click="tempImportSave()" class="btn btn-primary waves-effect waves-light m-r-10">
            {{ lang('Import') }}
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import moment from 'moment'
import { lang } from '../locale/index'
import GlobalFn from '../components/GlobalFn'
import Cookies from 'js-cookie'
import { checkIsMiddleton } from '@/helper/util_custom'
import configAdmin from '@/config/configAdmin'

export default {
  name: 'AttendanceList',
  data() {
    return {
      checkListSelect: configAdmin.attendanceOptions,
      ddlClassList: [],
      ddlClass: '',
      studentList: [],
      studentClass: [],
      studentCheck: [],
      selectedStudent: [],
      selectallStudent: false,
      bundleAttendance: false,
      hideStudentList: false,
      tempDeviceOutput: '',
      sortOptionsSelected: '',
      sortOptions: ['Student Name', 'Pickup Mode', 'ECA'],
      schID: '',
    }
  },
  async created() {
    this.schID = Cookies.get('schoolSession')
    await this.bindClasses()
  },
  async mounted() {
    if (checkIsMiddleton()) {
      this.checkListSelect = configAdmin.misAttendanceOptions
    }
  },
  computed: {
    currentDateWithAlphabet() {
      return moment().format('DD MMM YYYY')
    },
  },
  components: {
    GlobalFn,
  },
  methods: {
    lang,
    checkAllStudent(e) {
      if (this.selectallStudent === true) {
        this.bundleAttendance = true
        this.studentList.forEach(m => {
          m.checked = true
        })
      } else {
        this.bundleAttendance = false

        this.studentList.forEach(m => {
          m.checked = false
        })
      }
    },
    selectedAttendance() {
      this.studentList.forEach(m => {
        m.markingStatus = this.studentCheck
      })
    },
    AttendanceByStudent(value, item) {
      item.markingStatus = value
      this.$forceUpdate()
    },
    async bindClasses() {
      try {
        const response = await DataSource.shared.getAttendanceClassWithMode('GroupClasName')
        if (response) {
          this.class = response.dsGroupClass.Table
          this.class.forEach(m => {
            this.ddlClassList.push(m)
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    async Load() {
      try {
        this.sortOptionsSelected = ''

        if (this.ddlClass === '') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please select class'),
          })
        } else {
          this.$vs.loading()
          const response = await DataSource.shared.LoadAttendanceListWithMode(this.ddlClass, 'GroupClasName')
          if (response) {
            if (response.code === '2') {
              this.studentList = []
              this.hideStudentList = true
            } else if (response.code === '99') {
              this.$notify.error({
                title: lang('Error'),
                message: lang('Error! Please try again later'),
              })
            } else {
              this.studentList.forEach(m => {
                m.checked = false
              })
              this.studentList = response.Table
            }
          }
          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async Save() {
      this.$vs.loading()
      try {
        let attendanceList = []

        this.$refs.studentList_Update.forEach((m, index) => {
          let status = ''

          if (
            this.$refs.studentCheckList[index].value === undefined ||
            this.$refs.studentCheckList[index].value === null ||
            this.$refs.studentCheckList[index].value === ''
          ) {
            status = ''
          } else {
            status = this.$refs.studentCheckList[index].value
          }

          let attendanceDetials = {
            status: status,
            remark: this.$refs.studentRemark[index].value,
          }

          let attendanceListTemp = {
            studentIndexNo: this.$refs.studentIndexNo[index].value,
            attDetails: attendanceDetials,
          }
          attendanceList.push(attendanceListTemp)
        })

        if (attendanceList.length < 1) {
          this.$notify.error({
            title: lang('Require'),
            message: lang('Please at least tick at least one row to update'),
          })
        } else {
          const response = await DataSource.shared.updateAttendanceList(JSON.stringify(attendanceList))
          if (response) {
            if (response.code === '1') {
              this.$notify({
                title: lang('Success'),
                message: lang('Successfully saved'),
                type: 'success',
              })
              this.Load()
              this.selectallStudent = false
              this.studentCheck = ''
            } else {
              this.$notify.error({
                title: lang('Error'),
                message: lang('Error! Please try again later'),
              })
              window.location.replace('/attendancelist')
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async checkAll() {
      try {
        if (this.$refs.checkAllBox.checked == true) {
          this.$refs.studentCheckList.forEach(m => {
            m.checked = true
          })
        } else {
          this.$refs.studentCheckList.forEach(m => {
            m.checked = false
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    showTempImportModal() {
      this.tempDeviceOutput = ''
      this.$refs.tempImportModal.show()
    },
    async tempImportSave() {
      this.$vs.loading()
      try {
        const response = await DataSource.shared.updateAttendanceListWithTemperature(this.tempDeviceOutput)
        if (response) {
          if (response.code === '1') {
            this.$notify({
              title: lang('Success'),
              message: lang('Successfully saved'),
              type: 'success',
            })
          } else {
            this.$notify.error({
              title: lang('Error'),
              message: lang('Error! Please try again later'),
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    changeSort() {
      if (this.sortOptionsSelected === 'Student Name') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'Student_Name', 'asc')
      } else if (this.sortOptionsSelected === 'Pickup Mode') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'busOutNo', 'asc')
      } else if (this.sortOptionsSelected === 'ECA') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'ecaName', 'asc')
      }
    },
    showTemp(type) {
      if (type === 'qr') {
        window.location.replace('/StaffScanTemperature')
      } else if (type === 'non-qr') {
        window.location.replace('/StaffScanTemperatureWithBarCode')
      }
    },
    viewAttendanceList() {
      window.location.replace('/AttendanceListView')
    },
  },
}
</script>

<style lang="scss">
#attendance-list .attTable td {
  --input-height: 32px;
  border-width: 0 0 8px;

  .form-control,
  .el-input__inner {
    font-size: 14px;
    height: var(--input-height);
  }

  .el-input__inner,
  .el-input__icon {
    line-height: var(--input-height);
  }
}
</style>

<style scoped>
.attTable {
  width: 100%;
  margin-top: 20px;
}

.attTable td,
.attTable th {
  text-align: center;
  padding: 8px 10px !important;
}

.attTable tr:nth-child(even) {
  background: #fff;
}

.ddlClass {
  display: inline;
  width: auto;
}

.lblClass {
  display: inline !important;
  padding: 20px;
}

input[type='checkbox'] {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 5px;
  border: 2px solid #555;
}

.searchingArea {
  text-align: left;
}

.parentsMobileNo {
  background-color: #fff;
  background-image: none;
  border-radius: 20px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: var(--input-height);
  line-height: var(--input-height);
  outline: 0;
  padding: 0 15px;
}

.attendance-search .el-select {
  margin-left: 10px !important;
}

.taTempImport {
  width: 100%;
  border-radius: 5px;
  border: 0px;
  background: #ededed;
}

.tempImportButtonArea {
  margin: 10px 0 0 0;
}

.lblBusNo,
.lblStudentName,
.lblEcaName {
  font-weight: normal !important;
  margin-bottom: 0;
  padding-left: 10px;
}

.divSortBy {
  text-align: right;
}

.divSortBy label {
  display: inline !important;
  margin-right: 10px;
}
</style>
